import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/authentication/Login.vue'),
    props: true
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/authentication/Register.vue')
  },
  {
    path: '/register-provider',
    name: 'register-provider',
    component: () => import('../views/authentication/Register.vue'),
    props: {provider: true}
  },
  {
    path: '/confirm-email',
    name: 'confirm-email',
    component: () => import('../views/authentication/ConfirmAccount.vue')
  },
  {
    path: '/request-reset',
    name: 'request-reset',
    component: () => import('../views/authentication/RequestNewPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/authentication/ResetPassword.vue')
  },
  {
    path: '/monitoring/:pid',
    name: 'patient-monitoring-dashboard',
    component: () => import('../views/external/PatientMonitoringDashboard.vue')
  },
  {
    path: '/',
    name: 'app',
    component: () => import('../views/app/AppBase.vue'),
    redirect: 'home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/app/Home.vue'),
        beforeEnter: (to, from, next) => {
          if(store.getters.hasRole('admin') || store.getters.isExternalEntity) next({name: 'settings'})
          else next()
        }
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('../views/app/Calendar.vue'),
        beforeEnter: (to, from, next) => {
          if(store.getters.hasRole('admin')) next({name: 'settings'})
          else next()
        },
        props: true
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('../views/app/Settings.vue'),
        props: true
      },
      {
        path: 'settings/icd',
        name: 'icd',
        component: () => import('../views/admin/ICD.vue'),
        props: true
      },
      {
        path: 'custom-treatments/:ctid/pre-made-treatments',
        name: 'custom-pre-made-treatments',
        component: () => import('../views/app/PreMadeTreatment.vue'),
        props: true
      },
      {
        path: 'custom-treatments/:ctid/pre-made-treatments/:tid/edit',
        name: 'edit-custom-pre-made-treatment',
        component: () => import('../views/app/EditPreMadeTreatment.vue'),
        props: true
      },
      {
        path: 'custom-tests/:tid/edit',
        name: 'edit-custom-test',
        component: () => import('../views/app/CustomTest.vue'),
        props: true
      },
      {
        path: 'treatments/:category/pre-made-treatments',
        name: 'pre-made-treatments',
        component: () => import('../views/app/PreMadeTreatment.vue'),
        props: true
      },
      {
        path: 'treatments/:category/pre-made-treatments/:tid/edit',
        name: 'edit-pre-made-treatment',
        component: () => import('../views/app/EditPreMadeTreatment.vue'),
        props: true
      },
      {
        path: 'settings/supplements',
        name: 'supplements',
        component: () => import('../views/app/Supplements.vue'),
        props: true
      },
      {
        path: 'settings/supplements/:sid/edit',
        name: 'edit-product',
        component: () => import('../views/app/EditProduct.vue'),
        props: true
      },
      {
        path: 'settings/supplements/new',
        name: 'new-product',
        component: () => import('../views/app/NewProduct.vue'),
        props: true
      },
      {
        path: 'settings/cmm',
        name: 'cmm',
        component: () => import('../views/app/ChineseMedicalMatter.vue'),
        props: true
      },
      {
        path: 'settings/cmm/formulas/:sid/edit',
        name: 'edit-formula',
        component: () => import('../views/app/EditFormula.vue'),
        props: true
      },
      {
        path: 'settings/cmm/formulas/new',
        name: 'new-formula',
        component: () => import('../views/app/NewFormula.vue'),
        props: true
      },
      {
        path: 'settings/cmm/substances/new',
        name: 'new-substance',
        component: () => import('../views/app/NewSubstance.vue'),
        props: true
      },
      {
        path: 'settings/cmm/substances/:sid/edit',
        name: 'edit-substance',
        component: () => import('../views/app/EditSubstance.vue'),
        props: true
      },
      {
        path: 'settings/acupuncture',
        name: 'acupuncture',
        component: () => import('../views/admin/Acupuncture.vue'),
        props: {admin: false}
      },
      {
        path: 'settings/auricular-acupuncture',
        name: 'auricular-acupuncture',
        component: () => import('../views/admin/AcupunctureAuricular.vue'),
        props: {admin: false}
      },
      {
        path: 'settings/acupuncture/points',
        name: 'acu-points',
        component: () => import('../views/admin/AcupuncturePoints.vue'),
        props: {admin: false}
      },
      {
        path: 'patients',
        name: 'patients',
        component: () => import('../views/app/Patients.vue'),
      },
      {
        path: 'patients/new',
        name: 'new-patient',
        component: () => import('../views/app/NewPatient.vue')
      },
      {
        path: 'monitoring',
        name: 'monitoring',
        component: () => import('../views/app/Monitoring.vue'),
      },
      {
        path: 'modules',
        name: 'modules',
        component: () => import('../views/app/Modules.vue'),
        props: true
      },
      {
        path: 'modules/cart',
        name: 'cart',
        component: () => import('../views/app/BuyModule.vue'),
        props: true
      },
      {
        path: 'support',
        name: 'support',
        component: () => import('../views/app/Support.vue')
      },
      {
        path: 'patient/:pid',
        name: 'patient',
        component: () => import('../views/app/Patient.vue'),
        props: true
      },
      {
        path: 'patient/:pid/appointments/new',
        name: 'patient-new-appointment',
        component: () => import('../views/app/PatientNewAppointment.vue'),
        props: true
      },
      {
        path: 'patient/:pid/appointment/:aid',
        name: 'appointment',
        component: () => import('../views/app/Appointment.vue'),
        props: true
      },
      {
        path: 'user/:uid/edit',
        name: 'edit-user',
        component: () => import('../views/app/EditUser.vue'),
        props: true
      },
      {
        path: '/tests',
        name: 'tests',
        component: () => import('../views/app/Tests.vue'),
        props: true
      },
      {
        path: '/treatments',
        name: 'treatments',
        component: () => import('../views/app/Treatments.vue'),
        props: true
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin-login',
    component: () => import('../views/admin/AdminLogin.vue'),
    props: true
  },
  {
    path: '/admin/dashboard',
    name: 'dashboard',
    component: () => import('../views/admin/Dashboard.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/spaces',
    name: 'spaces',
    component: () => import('../views/admin/Spaces.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin || store.getters.isMarketing) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/payments',
    name: 'payments',
    component: () => import('../views/admin/Payments.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/spaces/:sid',
    name: 'manage-space',
    component: () => import('../views/admin/ManageSpace.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/modules',
    name: 'admin-modules',
    component: () => import('../views/admin/Modules.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/modules/:mid',
    name: 'edit-module',
    component: () => import('../views/admin/EditModule.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/supplements',
    name: 'admin-supplements',
    component: () => import('../views/app/Supplements.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/supplements/:sid/edit',
    name: 'admin-edit-product',
    component: () => import('../views/app/EditProduct.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/supplements/new',
    name: 'admin-new-product',
    component: () => import('../views/app/NewProduct.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/cmm',
    name: 'admin-cmm',
    component: () => import('../views/app/ChineseMedicalMatter.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/cmm/formulas/:sid/edit',
    name: 'admin-edit-formula',
    component: () => import('../views/app/EditFormula.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/cmm/formulas/new',
    name: 'admin-new-formula',
    component: () => import('../views/app/NewFormula.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/cmm/substances/:sid/edit',
    name: 'admin-edit-substance',
    component: () => import('../views/app/EditSubstance.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/cmm/substances/new',
    name: 'admin-new-substance',
    component: () => import('../views/app/NewSubstance.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/acupuncture',
    name: 'admin-acu',
    component: () => import('../views/admin/Acupuncture.vue'),
    props: {admin: true},
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/acupuncture/points',
    name: 'admin-acu-points',
    component: () => import('../views/admin/AcupuncturePoints.vue'),
    props: {admin: true},
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/acupuncture/points/:pid/edit',
    name: 'edit-acu-point',
    component: () => import('../views/app/EditAcuPoint.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/acupuncture/groups',
    name: 'admin-acu-groups',
    component: () => import('../views/admin/AcupunctureGroups.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/acupuncture/groups/:gid/edit',
    name: 'edit-acu-group',
    component: () => import('../views/app/EditAcuGroup.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/tests/tongue',
    name: 'admin-tongue',
    component: () => import('../views/admin/Tongue.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/product-properties',
    name: 'product-properties',
    component: () => import('../views/admin/ProductProperties.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/osteo-settings',
    name: 'osteo-settings',
    component: () => import('../views/admin/OsteoSettings.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/ryodoraku',
    name: 'admin-ryodoraku',
    component: () => import('../views/admin/Ryodoraku.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/treatments/pulse',
    name: 'admin-pulse',
    component: () => import('../views/admin/Pulse.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/bibliographic-references',
    name: 'bibliographic-references',
    component: () => import('../views/admin/BibliographicReferences.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isStaff) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/alerts',
    name: 'alerts',
    component: () => import('../views/admin/Alerts.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/terms-conditions',
    name: 'terms-conditions',
    component: () => import('../views/admin/TermsConditions.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../views/admin/PrivacyPolicy.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/patient-consent',
    name: 'patient-consent',
    component: () => import('../views/admin/PatientConsent.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/question-answers',
    name: 'question-answers',
    component: () => import('../views/admin/QuestionAnswers.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/subscription-plans',
    name: 'subscription-plans',
    component: () => import('../views/admin/SubscriptionPlans.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/discount-codes',
    name: 'discount-codes',
    component: () => import('../views/admin/DiscountCodes.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin || store.getters.isMarketing) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/subscription-plans/:pid',
    name: 'edit-subscription-plan',
    component: () => import('../views/admin/EditSubscriptionPlan.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/icd',
    name: 'icd-admin',
    component: () => import('../views/admin/ICD.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/icd/new',
    name: 'new-icd',
    component: () => import('../views/admin/NewICD.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/icd/:iid',
    name: 'edit-icd',
    component: () => import('../views/admin/EditICD.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/extension/new',
    name: 'new-extension',
    component: () => import('../views/admin/NewExtension.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/extension/:eid',
    name: 'edit-extension',
    component: () => import('../views/admin/EditExtension.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/drugs',
    name: 'drugs',
    component: () => import('../views/admin/Drugs.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/drugs/new',
    name: 'new-drug',
    component: () => import('../views/admin/NewDrug.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/drugs/:did',
    name: 'edit-drug',
    component: () => import('../views/admin/EditDrug.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/emails',
    name: 'emails',
    component: () => import('../views/admin/Emails.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin || store.getters.isMarketing) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '/admin/dashboard/email-sms',
    name: 'email-sms',
    component: () => import('../views/admin/EmailSMS.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if(store.getters.isSuperAdmin) next()
      else next({name: 'admin-login'})
    }
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('../views/external/NotFound.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const noAuthenticationRoutes = ['not-found', 'patient-monitoring-dashboard', 'login', 'logout', 'register', 'admin-login', 'request-reset', 'reset-password', 'confirm-email', 'register-provider']
const externalEntityRoutes = ['home', 'settings', 'edit-user', 'cmm', 'supplements', 'cmm', 'new-product', 'edit-product', 'new-formula', 'edit-formula']

router.beforeEach((to, from, next) => {
	if(noAuthenticationRoutes.includes(to.name)) {
		const browserLanguage = navigator.languages[0];
		if(browserLanguage) {
			var language = browserLanguage.split("-")[0];
			if(language == 'pt' || language == 'en') store.dispatch("UPDATE_LANGUAGE", language);
		}
		next()
	} else if (!store.getters.existUser) {
		axios
			.get("/refresh_user")
			.then(response => {
				console.log('REFRESH USER');
				if (response.status === 200) {
					store.dispatch("UPDATE_USER", response.data.user);
          if(store.getters.isExternalEntity && !externalEntityRoutes.includes(to.name)) next('/not-found');
					next();
				} else {
					next('/login');
				}
			})
			.catch(error => { console.log(error); next('/login') });
	} else if(store.getters.isExternalEntity && !externalEntityRoutes.includes(to.name)) {
    next('/not-found');
  } else next()
})

export default router
